import { put } from 'redux-saga/effects';
import { doShowSnackbar } from '../actions/ui';

function* handleShowResponse(action) {
  const { type, text } = action.payload;

  yield put(doShowSnackbar(type, text));
}

export { handleShowResponse };
